"use strict";

var cart = require("../cart/cart");

var updateMiniCart = true;
var location = window.location;

/**
* Displays an alert message in the mini cart UI based on the response data.
* Stops any active spinner, appends an alert message to the DOM, and removes it after a short delay.
* @param {Object} data - The response data containing the message and success status.
* @param {boolean} data.success - Indicates if the operation was successful.
* @param {string} data.msg - The message to display in the alert.
*/
function displayAlertMessage(data) {
    $.spinner().stop();
    let status = data && data.success && !data.isRemoveProduct ? "alert-success" : "alert-danger";
    let message = data ? data.msg : "";

    if ($(".add-to-cart-messages").length === 0) {
        $("body").append("<div class=\"add-to-cart-messages \"></div>");
    }

    $(".add-to-cart-messages").append("<div class=\"alert add-to-basket-alert text-center " + status + "\">" + message + "</div>");

    setTimeout(function () {
        $(".add-to-cart-messages").remove();
    }, 1500);
}

/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
    $("body").on("click", ".product-move .move", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $button = $this.find(".add-to-wish-list");
        var isRemoveFromWishlist = $button.hasClass("wishlist-added");
        var url = isRemoveFromWishlist ? $this.data("remove-url") : $this.attr("href");
        var pid = $this.data("pid");
        var optionId = $this.closest(".product-info").find(".lineItem-options-values").data("option-id");
        var optionVal = $this.closest(".product-info").find(".lineItem-options-values").data("value-id");
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: isRemoveFromWishlist ? "get" : "post",
            dataType: "json",
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal,
                triggeredFrom: "Cart-Show"
            },
            success: function (data) {
                $.spinner().stop();
                if (data.isGuest) {
                    var $loginModal = $("#loginModal");
                    var $loginModalLink = $loginModal.find(".login-modal-link");

                    if ($loginModalLink.length) {
                        $loginModalLink.attr("href", data.loginUrl);
                        $loginModal.modal("show");
                    }
                } else {
                    displayAlertMessage(data, $button);
                    $button.toggleClass("wishlist-added");
                }
            },
            error: function (err) {
                $.spinner().stop();
                displayAlertMessage(err);
            }
        });
    });
}

export default function minicart() {
    cart();
    moveToWishlist();

    $(".minicart").on("count:update", function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $(".minicart .minicart-quantity").text(count.quantityTotal);
            $(".minicart .minicart-link").attr({
                "aria-label": count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $(".minicart").on("mouseenter focusin touchstart", function () {
        if ($(".search:visible").length === 0) {
            return;
        }
        var url = $(".minicart").data("action-url");
        var count = parseInt($(".minicart .minicart-quantity").text(), 10);

        if (count !== 0 && $(".minicart .popover.show").length === 0) {
            if (!updateMiniCart) {
                $(".minicart .popover").addClass("show");
                return;
            }

            $(".minicart .popover").addClass("show");
            $(".minicart .popover").spinner().start();
            $.get(url, function (data) {
                $(".minicart .popover").empty();
                $(".minicart .popover").append(data);
                updateMiniCart = false;
                $.spinner().stop();
            });
        }
    });
    $("body").on("touchstart click", function (e) {
        if ($(".minicart").has(e.target).length <= 0) {
            $(".minicart .popover").removeClass("show");
        }
    });
    $(".minicart").on("mouseleave focusout", function (event) {
        if ((event.type === "focusout" && $(".minicart").has(event.target).length > 0)
            || (event.type === "mouseleave" && $(event.target).is(".minicart .quantity"))
            || $("body").hasClass("modal-open")) {
            event.stopPropagation();
            return;
        }
        $(".minicart .popover").removeClass("show");
    });
    $("body").on("change", ".minicart .quantity", function () {
        if ($(this).parents(".bonus-product-line-item").length && $(".cart-page").length) {
            location.reload();
        }
    });
    $("body").on("product:afterAddToCart", function () {
        updateMiniCart = true;
    });
    $("body").on("cart:update", function () {
        updateMiniCart = true;
    });
}
